import { render, staticRenderFns } from "./input-textarea.vue?vue&type=template&id=c317a064&scoped=true"
import script from "./input-textarea.vue?vue&type=script&lang=js"
export * from "./input-textarea.vue?vue&type=script&lang=js"
import style0 from "./input-textarea.vue?vue&type=style&index=0&id=c317a064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c317a064",
  null
  
)

export default component.exports